import { useState } from 'react';
import { hapticFeedback } from '@telegram-apps/sdk';
import { useCleanup } from '../../hooks';
import './Admin.css';

export function CleanupSection() {
  const [showConfirmRequests, setShowConfirmRequests] = useState(false);
  const [showConfirmHistory, setShowConfirmHistory] = useState(false);

  const {
    cleanupRequests,
    isCleaningRequests,
    cleanupRequestsResult,
    cleanupHistory,
    isCleaningHistory,
    cleanupHistoryResult,
  } = useCleanup();

  const handleCleanupRequests = async () => {
    setShowConfirmRequests(false);
    if (hapticFeedback.impactOccurred.isAvailable()) {
      hapticFeedback.impactOccurred('heavy');
    }
    try {
      await cleanupRequests(30);
      if (hapticFeedback.notificationOccurred.isAvailable()) {
        hapticFeedback.notificationOccurred('success');
      }
    } catch {
      if (hapticFeedback.notificationOccurred.isAvailable()) {
        hapticFeedback.notificationOccurred('error');
      }
    }
  };

  const handleCleanupHistory = async () => {
    setShowConfirmHistory(false);
    if (hapticFeedback.impactOccurred.isAvailable()) {
      hapticFeedback.impactOccurred('heavy');
    }
    try {
      await cleanupHistory(90);
      if (hapticFeedback.notificationOccurred.isAvailable()) {
        hapticFeedback.notificationOccurred('success');
      }
    } catch {
      if (hapticFeedback.notificationOccurred.isAvailable()) {
        hapticFeedback.notificationOccurred('error');
      }
    }
  };

  return (
    <div className="admin-section">
      <div className="admin-section-header">
        <div className="admin-section-header-left">
          <span className="admin-section-icon">🧹</span>
          <span className="admin-section-title">Очистка данных</span>
        </div>
      </div>

      <div className="admin-section-body">
        <div className="admin-cleanup-warning">
          <span className="admin-cleanup-warning-icon">⚠️</span>
          <span className="admin-cleanup-warning-text">
            Удаление старых данных для освобождения места в базе данных.
            Будьте осторожны — это действие необратимо!
          </span>
        </div>

        <div className="admin-cleanup-buttons">
          <button
            type="button"
            className="admin-btn admin-btn--danger"
            onClick={() => setShowConfirmRequests(true)}
            disabled={isCleaningRequests}
          >
            {isCleaningRequests ? (
              <>
                <span className="admin-btn-spinner" />
                Очистка...
              </>
            ) : (
              <>🗑️ Очистить заявки старше 30 дней</>
            )}
          </button>

          <button
            type="button"
            className="admin-btn admin-btn--danger"
            onClick={() => setShowConfirmHistory(true)}
            disabled={isCleaningHistory}
          >
            {isCleaningHistory ? (
              <>
                <span className="admin-btn-spinner" />
                Очистка...
              </>
            ) : (
              <>📜 Очистить историю старше 90 дней</>
            )}
          </button>
        </div>

        {cleanupRequestsResult && (
          <div className="admin-cleanup-result">
            <span className="admin-cleanup-result-icon">✅</span>
            <span className="admin-cleanup-result-text">
              Удалено заявок: {cleanupRequestsResult.deletedRequests},
              истории: {cleanupRequestsResult.deletedHistory}
            </span>
          </div>
        )}

        {cleanupHistoryResult && (
          <div className="admin-cleanup-result">
            <span className="admin-cleanup-result-icon">✅</span>
            <span className="admin-cleanup-result-text">
              Удалено записей истории: {cleanupHistoryResult.deleted}
            </span>
          </div>
        )}
      </div>

      {/* Confirmation modal for requests */}
      {showConfirmRequests && (
        <div className="admin-modal-overlay" onClick={() => setShowConfirmRequests(false)}>
          <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
            <div className="admin-modal-icon">⚠️</div>
            <div className="admin-modal-title">Подтверждение удаления</div>
            <div className="admin-modal-text">
              Вы уверены, что хотите удалить все заявки старше 30 дней?
              Это действие необратимо.
            </div>
            <div className="admin-modal-buttons">
              <button
                type="button"
                className="admin-modal-btn admin-modal-btn--cancel"
                onClick={() => setShowConfirmRequests(false)}
              >
                Отмена
              </button>
              <button
                type="button"
                className="admin-modal-btn admin-modal-btn--confirm"
                onClick={handleCleanupRequests}
              >
                Удалить
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation modal for history */}
      {showConfirmHistory && (
        <div className="admin-modal-overlay" onClick={() => setShowConfirmHistory(false)}>
          <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
            <div className="admin-modal-icon">⚠️</div>
            <div className="admin-modal-title">Подтверждение удаления</div>
            <div className="admin-modal-text">
              Вы уверены, что хотите удалить всю историю старше 90 дней?
              Это действие необратимо.
            </div>
            <div className="admin-modal-buttons">
              <button
                type="button"
                className="admin-modal-btn admin-modal-btn--cancel"
                onClick={() => setShowConfirmHistory(false)}
              >
                Отмена
              </button>
              <button
                type="button"
                className="admin-modal-btn admin-modal-btn--confirm"
                onClick={handleCleanupHistory}
              >
                Удалить
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
